@if (!getExperimentError()) {
  <div id="experiment--container">
    <div id="nav--container">
      <app-option-tab-toggle
        radioGroup="navigationToggle"
        [selectOptions]="navOptions"
        type="round"
        id="toggle--container"
      >
      </app-option-tab-toggle>
    </div>
    <hr />
    @if (devices.length > 0) {
      <div id="inner-page--container">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Experiment Details</div>
                <div class="body2 last-updated">
                  Page last refreshed:
                  {{ experimentDataLastUpdated() | date: "MMM d, y h:mm a" }}
                  <app-mat-icon-button
                    buttonStyle="negative"
                    buttonId="delete-btn"
                    ariaLabel="Delete experiment"
                    iconName="delete"
                    (buttonClicked)="openModal('delete-experiment')"
                    [isDisabled]="
                      experiment?.isDeleted === true ||
                      deleteIsProcessing() ||
                      !(currentUser().role | roleCheck: labAdminRoles)
                    "
                    (click)="$event.stopPropagation()"
                  ></app-mat-icon-button>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div id="experiment-details--container">
              <div class="details body1">
                <div class="experiment-mode">
                  <mat-icon>science</mat-icon
                  >{{ ExperimentModeDisplay[experiment?.experimentMode] }}
                </div>
                <div class="divider">|</div>
                <div>
                  @if (experiment?.isDeleted === false) {
                    <app-status-indicator
                      [status]="
                        ExperimentStatus[experiment?.experimentStatusId]
                      "
                    ></app-status-indicator>
                  }
                  @if (experiment?.isDeleted) {
                    <app-status-indicator
                      status="Deleted"
                    ></app-status-indicator>
                  }
                </div>
              </div>
              <div id="details-buttons--container">
                <app-icon-button
                  label="update"
                  buttonId="update-btn"
                  buttonStyle="outlined"
                  (buttonClicked)="getExperiment()"
                  [isProcessing]="loading()"
                  iconName="autorenew"
                  buttonShape="square"
                ></app-icon-button>
                <app-icon-button
                  iconName="pause_circle"
                  [label]="
                    areDevicesPaused() === true
                      ? 'restart devices'
                      : 'pause devices'
                  "
                  buttonId="pause-btn"
                  buttonStyle="outlined"
                  buttonShape="square"
                  (buttonClicked)="pauseRestartButtonClicked()"
                  [isProcessing]="pauseDevicesProcessing()"
                  [isDisabled]="
                    experiment?.isDeleted === true ||
                    (experiment?.experimentStatusId !==
                      ExperimentStatus.Active &&
                      experiment?.experimentStatusId !==
                        ExperimentStatus.Paused) ||
                    !hasEditAccess()
                  "
                >
                </app-icon-button>
                <app-icon-button
                  iconName="stop"
                  label="stop experiment"
                  buttonId="stop-btn"
                  buttonStyle="outlined"
                  buttonShape="square"
                  (buttonClicked)="openModal('stop-experiment')"
                  [isProcessing]="stopExperimentProcessing()"
                  [isDisabled]="
                    experiment?.experimentStatusId !==
                      ExperimentStatus.Active ||
                    experiment?.isDeleted === true ||
                    !(currentUser().role | roleCheck: editAccessRoles)
                  "
                >
                </app-icon-button>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="accordion-controls">
          <button type="button" (click)="accordion.openAll()">
            Expand all
          </button>
          <div aria-hidden="true">|</div>
          <button type="button" (click)="accordion.closeAll()">
            Collapse all
          </button>
        </div>
        <form>
          <mat-accordion multi #accordion="matAccordion">
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="expansion-header">Experiment Controls</div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="notifications--container">
                <div class="notifications">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="enableNotificationsField"
                    [tooltipText]="notificationTooltip"
                  ></app-slide-toggle>
                  <div class="select--container">
                    @if (labMemembersDropdownLoading()) {
                      <div>
                        <app-small-loading-spinner></app-small-loading-spinner>
                      </div>
                    } @else if (getLabUsersError()) {
                      <div
                        class="error body2"
                        role="alert"
                        aria-live="assertive"
                      >
                        Error: Unable to fetch laboratory users.
                        <app-underlined-text-button
                          label="Retry"
                          ariaLabel="Retry loading laboratory users"
                          (buttonClicked)="getLabMembers()"
                        ></app-underlined-text-button>
                      </div>
                    } @else {
                      <app-underlined-dropdown-form-field
                        [parentForm]="experimentUpdateForm"
                        [field]="notificationEmailField"
                      ></app-underlined-dropdown-form-field>
                    }
                  </div>
                </div>
                @if (
                  !experimentUpdateForm.get(notificationEmailField.key)
                    ?.disabled
                ) {
                  <div class="body1">
                    {{ selectedNotificationUser()?.firstName }}
                    {{ selectedNotificationUser()?.lastName }}:
                    {{ selectedNotificationUser()?.role | formatRole }}
                  </div>
                }
              </div>
              <div class="underlined-form-field-grid">
                <app-underlined-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="experimentNameField"
                ></app-underlined-form-field>
                <app-underlined-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="organismField"
                ></app-underlined-form-field>
                <app-underlined-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="strainField"
                ></app-underlined-form-field>
                <app-underlined-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="mediaField"
                ></app-underlined-form-field>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="expansion-header">Base Unit</div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="base-unit-time-grid">
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="samplingTimeField"
                  [minValue]="minSampleTimeInMins"
                  [maxValue]="maxSampleTimeInMins"
                  [step]="sampleTimeStep"
                  [labelAbove]="true"
                ></app-number-form-field>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="experimentTimeField"
                  [minValue]="minExperimentTimeInHours"
                  [maxValue]="maxExperimentTimeInHours"
                  [step]="experimentTimeStep"
                  [labelAbove]="true"
                ></app-number-form-field>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="ambientTemperatureField"
                  [minValue]="minAmbientTemp"
                  [maxValue]="maxAmbientTemp"
                  [step]="ambientTempStep"
                  [labelAbove]="true"
                ></app-number-form-field>
              </div>
              <div class="card-grid">
                <div class="button-header">
                  <div class="grey-label">FLASK TEMPERATURE CONTROLS</div>
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="temp-controls-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyTempControlValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !==
                        ExperimentStatus.Active &&
                        experiment?.experimentStatusId !==
                          ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureControlAField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureAField"
                    [minValue]="minCultureTemp"
                    [maxValue]="maxCultureTemp"
                    [step]="cultureTempStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureControlBField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureBField"
                    [minValue]="minCultureTemp"
                    [maxValue]="maxCultureTemp"
                    [step]="cultureTempStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureControlCField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureCField"
                    [minValue]="minCultureTemp"
                    [maxValue]="maxCultureTemp"
                    [step]="cultureTempStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureControlDField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="temperatureDField"
                    [minValue]="minCultureTemp"
                    [maxValue]="maxCultureTemp"
                    [step]="cultureTempStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="card-grid">
                <div class="button-header">
                  <div class="grey-label">STIRRING SPEED CONTROLS</div>
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="stirring-speed-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyStirringSpeedValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !==
                        ExperimentStatus.Active &&
                        experiment?.experimentStatusId !==
                          ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="setStirringSpeedAField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="speedAField"
                    [minValue]="minSpeed"
                    [maxValue]="maxSpeed"
                    [step]="speedStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="setStirringSpeedBField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="speedBField"
                    [minValue]="minSpeed"
                    [maxValue]="maxSpeed"
                    [step]="speedStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="setStirringSpeedCField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="speedCField"
                    [minValue]="minSpeed"
                    [maxValue]="maxSpeed"
                    [step]="speedStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="setStirringSpeedDField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="speedDField"
                    [minValue]="minSpeed"
                    [maxValue]="maxSpeed"
                    [step]="speedStep"
                  ></app-number-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.Turbidostat
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.Turbidostat
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>Turbidostat</h6>
                </mat-panel-title>
                @if (experiment.experimentMode !== ExperimentMode.Turbidostat) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="card-grid">
                <div class="button-header">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="maintainODField"
                  ></app-slide-toggle>
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="turbidostat-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyTurbidostatControlValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !==
                        ExperimentStatus.Active &&
                        experiment?.experimentStatusId !==
                          ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="turbAActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="targetODAField"
                    [minValue]="minTargetOD"
                    [maxValue]="maxTargetOD"
                    [step]="targetODStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="turbBActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="targetODBField"
                    [minValue]="minTargetOD"
                    [maxValue]="maxTargetOD"
                    [step]="targetODStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="turbCActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="targetODCField"
                    [minValue]="minTargetOD"
                    [maxValue]="maxTargetOD"
                    [step]="targetODStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="turbDActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="targetODDField"
                    [minValue]="minTargetOD"
                    [maxValue]="maxTargetOD"
                    [step]="targetODStep"
                  ></app-number-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.Chemostat
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.Chemostat
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>Chemostat</h6>
                </mat-panel-title>
                @if (experiment.experimentMode !== ExperimentMode.Chemostat) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="card-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="chemostat-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyChemostatControlValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="chemoAActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="flowRateAField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="chemoBActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="flowRateBField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="chemoCActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="flowRateCField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="chemoDActiveField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="flowRateDField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.PHControl
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.PHControl
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>pH Control</h6>
                </mat-panel-title>
                @if (experiment.experimentMode !== ExperimentMode.PHControl) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="ph-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="ph-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyPHValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phControlAField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHAField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationAField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-radio-a"
                      [field]="inputTypeAField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeAField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phControlBField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHBField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationBField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-radio-b"
                      [field]="inputTypeBField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeBField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phControlCField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHCField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationCField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-radio-c"
                      [field]="inputTypeCField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeCField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phControlDField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHDField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationDField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-radio-d"
                      [field]="inputTypeDField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeDField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.PHControlDouble
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.PHControlDouble
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>BETA: pH 2xControl</h6>
                </mat-panel-title>
                @if (
                  experiment.experimentMode !== ExperimentMode.PHControlDouble
                ) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="ph-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B"
                    ariaLabel="Copy A to B"
                    buttonId="ph-double-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyPHDoubleValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="ph2ControlAField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPH2AField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDuration2AField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="ph2ControlBField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPH2BField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDuration2BField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.PHControlChemostat
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.PHControlChemostat
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>BETA: pH + Chemostat</h6>
                </mat-panel-title>
                @if (
                  experiment.experimentMode !==
                  ExperimentMode.PHControlChemostat
                ) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="ph-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B"
                    ariaLabel="Copy A to B"
                    buttonId="ph-chemostat-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyPHChemostatValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phChemoControlAField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHChemoAField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationChemoAField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-chemo-radio-a"
                      [field]="inputTypeChemoAField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeChemoAField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="flowRatePHAField"
                      [minValue]="minFlowRate"
                      [maxValue]="maxFlowRate"
                      [step]="flowRateStep"
                    ></app-number-form-field>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="phChemoControlBField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="targetPHChemoBField"
                      [minValue]="minTargetPH"
                      [maxValue]="maxTargetPH"
                      [step]="targetPHStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="pumpDurationChemoBField"
                      [minValue]="minPumpDuration"
                      [maxValue]="maxPumpDuration"
                      [step]="pumpDurationStep"
                    ></app-number-form-field>
                    <app-radio-button
                      id="ph-chemo-radio-b"
                      [field]="inputTypeChemoBField"
                      [parentForm]="experimentUpdateForm"
                      [currentValue]="
                        experimentUpdateForm?.controls[inputTypeChemoBField.key]
                          ?.value
                      "
                      legendStyle="small"
                      size="small"
                    ></app-radio-button>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="flowRatePHBField"
                      [minValue]="minFlowRate"
                      [maxValue]="maxFlowRate"
                      [step]="flowRateStep"
                    ></app-number-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="
                experiment.experimentMode === ExperimentMode.Morbidostat
              "
              [disabled]="
                experiment.experimentMode !== ExperimentMode.Morbidostat
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>BETA: Morbidostat</h6>
                </mat-panel-title>
                @if (experiment.experimentMode !== ExperimentMode.Morbidostat) {
                  <mat-panel-description>
                    Mode not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <app-mat-outlined-button
                label="Copy A to B, C, D"
                ariaLabel="Copy A to B, C, D"
                buttonId="morbidostat-copy-btn"
                iconName="content_copy"
                iconPosition="left"
                (buttonClicked)="copyMorbidostatValues()"
                [isDisabled]="
                  !(currentUser().role | roleCheck: editAccessRoles) ||
                  (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                    experiment?.experimentStatusId !== ExperimentStatus.Paused)
                "
              ></app-mat-outlined-button>
              <div class="ph-grid">
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="morbidostatAActiveField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="thresholdODAField"
                      [minValue]="minThreshold"
                      [maxValue]="maxThreshold"
                      [step]="thresholdStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionPeriodAField"
                      [minValue]="minDilutionPeriod"
                      [maxValue]="maxDilutionPeriod"
                      [step]="dilutionPeriodStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionFactorAField"
                      [minValue]="minDilutionFactor"
                      [maxValue]="maxDilutionFactor"
                      [step]="dilutionFactorStep"
                    ></app-number-form-field>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="morbidostatBActiveField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="thresholdODBField"
                      [minValue]="minThreshold"
                      [maxValue]="maxThreshold"
                      [step]="thresholdStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionPeriodBField"
                      [minValue]="minDilutionPeriod"
                      [maxValue]="maxDilutionPeriod"
                      [step]="dilutionPeriodStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionFactorBField"
                      [minValue]="minDilutionFactor"
                      [maxValue]="maxDilutionFactor"
                      [step]="dilutionFactorStep"
                    ></app-number-form-field>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="morbidostatCActiveField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="thresholdODCField"
                      [minValue]="minThreshold"
                      [maxValue]="maxThreshold"
                      [step]="thresholdStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionPeriodCField"
                      [minValue]="minDilutionPeriod"
                      [maxValue]="maxDilutionPeriod"
                      [step]="dilutionPeriodStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionFactorCField"
                      [minValue]="minDilutionFactor"
                      [maxValue]="maxDilutionFactor"
                      [step]="dilutionFactorStep"
                    ></app-number-form-field>
                  </div>
                </div>
                <div class="ph-card">
                  <div class="toggle">
                    <app-slide-toggle
                      [parentForm]="experimentUpdateForm"
                      [field]="morbidostatDActiveField"
                    ></app-slide-toggle>
                  </div>
                  <div class="fields">
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="thresholdODDField"
                      [minValue]="minThreshold"
                      [maxValue]="maxThreshold"
                      [step]="thresholdStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionPeriodDField"
                      [minValue]="minDilutionPeriod"
                      [maxValue]="maxDilutionPeriod"
                      [step]="dilutionPeriodStep"
                    ></app-number-form-field>
                    <app-number-form-field
                      [parentForm]="experimentUpdateForm"
                      [field]="dilutionFactorDField"
                      [minValue]="minDilutionFactor"
                      [maxValue]="maxDilutionFactor"
                      [step]="dilutionFactorStep"
                    ></app-number-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="experiment.useOxygen"
              [disabled]="!experiment.useOxygen"
            >
              <mat-expansion-panel-header>
                <mat-panel-title><h6>Oxygen</h6></mat-panel-title>
                @if (!experiment.useOxygen) {
                  <mat-panel-description>
                    Module not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="oxygen-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="oxygen-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyOxygenValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="salinityAField"
                  [minValue]="minSalinity"
                  [maxValue]="maxSalinity"
                  [step]="salinityStep"
                ></app-number-form-field>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="salinityBField"
                  [minValue]="minSalinity"
                  [maxValue]="maxSalinity"
                  [step]="salinityStep"
                ></app-number-form-field>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="salinityCField"
                  [minValue]="minSalinity"
                  [maxValue]="maxSalinity"
                  [step]="salinityStep"
                ></app-number-form-field>
                <app-number-form-field
                  [parentForm]="experimentUpdateForm"
                  [field]="salinityDField"
                  [minValue]="minSalinity"
                  [maxValue]="maxSalinity"
                  [step]="salinityStep"
                ></app-number-form-field>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="useFluorescence">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="expansion-header">Fluorescence</div>
                </mat-panel-title>
                @if (!useFluorescence) {
                  <mat-panel-description>
                    <div id="fluorescence-warning">
                      Module not selected for fluorescence measurement (LED
                      controls still available)
                      <span class="body2"
                        >Fluorescence settings will only apply if the device has
                        the module installed</span
                      >
                    </div>
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="card-grid">
                <div class="button-header">
                  <div class="grey-label">LED CONTROLS</div>
                  <app-mat-outlined-button
                    label="Copy 1 to 2, 3"
                    ariaLabel="Copy 1 to 2, 3"
                    buttonId="led-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyLEDValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !==
                        ExperimentStatus.Active &&
                        experiment?.experimentStatusId !==
                          ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="led1OnField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="led1IntensityField"
                    [minValue]="minLEDIntensity"
                    [maxValue]="maxLEDIntensity"
                    [step]="ledIntensityStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="led2OnField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="led2IntensityField"
                    [minValue]="minLEDIntensity"
                    [maxValue]="maxLEDIntensity"
                    [step]="ledIntensityStep"
                  ></app-number-form-field>
                </div>
                <div class="card">
                  <app-slide-toggle
                    [parentForm]="experimentUpdateForm"
                    [field]="led3OnField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="led3IntensityField"
                    [minValue]="minLEDIntensity"
                    [maxValue]="maxLEDIntensity"
                    [step]="ledIntensityStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="card-grid">
                <div class="button-header">
                  <div class="grey-label">INTEGRATION TIME & GAIN</div>
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="integration-time-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copyIntegrationTimeValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !==
                        ExperimentStatus.Active &&
                        experiment?.experimentStatusId !==
                          ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="card">
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="integrationTimeAField"
                    [minValue]="minIntegrationTime"
                    [maxValue]="maxIntegrationTime"
                    [step]="integrationTimeStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="gain-radio-a"
                    [field]="specGainAField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[specGainAField.key]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
                <div class="card">
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="integrationTimeBField"
                    [minValue]="minIntegrationTime"
                    [maxValue]="maxIntegrationTime"
                    [step]="integrationTimeStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="gain-radio-b"
                    [field]="specGainBField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[specGainBField.key]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
                <div class="card">
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="integrationTimeCField"
                    [minValue]="minIntegrationTime"
                    [maxValue]="maxIntegrationTime"
                    [step]="integrationTimeStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="gain-radio-c"
                    [field]="specGainCField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[specGainCField.key]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
                <div class="card">
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="integrationTimeDField"
                    [minValue]="minIntegrationTime"
                    [maxValue]="maxIntegrationTime"
                    [step]="integrationTimeStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="gain-radio-d"
                    [field]="specGainDField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[specGainDField.key]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
              </div>
              <span class="subtitle2 fluorescence-label">Fluorescence Channels</span>
              @if (experiment.fluorescenceChannels?.length === 0) {
                <p class="no-channels body1">
                  No fluorescence channels selected
                </p>
              }
              @if (experiment.fluorescenceChannels?.length > 0) {
                <div class="channels-grid">
                  @for (
                    channel of experiment.fluorescenceChannels;
                    track channel.memorySlot
                  ) {
                    <app-fluorescence-channel-card
                      [channel]="channel"
                      [displayButton]="false"
                      [isDisabled]="
                        experiment?.isDeleted === true ||
                        (experiment?.experimentStatusId !==
                          ExperimentStatus.Active &&
                          experiment?.experimentStatusId !==
                            ExperimentStatus.Paused)
                      "
                    ></app-fluorescence-channel-card>
                  }
                </div>
              }
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="experiment.useSparging"
              [disabled]="!experiment.useSparging"
            >
              <mat-expansion-panel-header>
                <mat-panel-title><h6>Sparging</h6></mat-panel-title>
                @if (!experiment.useSparging) {
                  <mat-panel-description>
                    Module not selected
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <div class="sparging-grid">
                <div class="button-header">
                  <app-mat-outlined-button
                    label="Copy A to B, C, D"
                    ariaLabel="Copy A to B, C, D"
                    buttonId="sparging-copy-btn"
                    iconName="content_copy"
                    iconPosition="left"
                    (buttonClicked)="copySpargingValues()"
                    [isDisabled]="
                      !(currentUser().role
                        | roleCheck
                          : editAccessRoles) ||
                      (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                        experiment?.experimentStatusId !== ExperimentStatus.Paused)
                    "
                  ></app-mat-outlined-button>
                </div>
                <div class="sparging-card">
                  <app-radio-button
                    id="sparging-radio-a"
                    [field]="spargingControlTypeAField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[
                        spargingControlTypeAField.key
                      ]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="airflowAField"
                    [minValue]="minAirflow"
                    [maxValue]="maxAirflow"
                    [step]="airflowStep"
                    [warningMessage]="airflowRateWarningMessage"
                    [showWarning]="experimentUpdateForm?.controls[airflowAField.key]?.value >= airflowWarningValue"
                  ></app-number-form-field>
                </div>
                <div class="sparging-card">
                  <app-radio-button
                    id="sparging-radio-b"
                    [field]="spargingControlTypeBField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[
                        spargingControlTypeBField.key
                      ]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="airflowBField"
                    [minValue]="minAirflow"
                    [maxValue]="maxAirflow"
                    [step]="airflowStep"
                    [warningMessage]="airflowRateWarningMessage"
                    [showWarning]="experimentUpdateForm?.controls[airflowBField.key]?.value >= airflowWarningValue"
                  ></app-number-form-field>
                </div>
                <div class="sparging-card">
                  <app-radio-button
                    id="sparging-radio-c"
                    [field]="spargingControlTypeCField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[
                        spargingControlTypeCField.key
                      ]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="airflowCField"
                    [minValue]="minAirflow"
                    [maxValue]="maxAirflow"
                    [step]="airflowStep"
                    [warningMessage]="airflowRateWarningMessage"
                    [showWarning]="experimentUpdateForm?.controls[airflowCField.key]?.value >= airflowWarningValue"
                  ></app-number-form-field>
                </div>
                <div class="sparging-card">
                  <app-radio-button
                    id="sparging-radio-d"
                    [field]="spargingControlTypeDField"
                    [parentForm]="experimentUpdateForm"
                    [currentValue]="
                      experimentUpdateForm?.controls[
                        spargingControlTypeDField.key
                      ]?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentUpdateForm"
                    [field]="airflowDField"
                    [minValue]="minAirflow"
                    [maxValue]="maxAirflow"
                    [step]="airflowStep"
                    [warningMessage]="airflowRateWarningMessage"
                    [showWarning]="experimentUpdateForm?.controls[airflowDField.key]?.value >= airflowWarningValue"
                  ></app-number-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h6>Notes</h6></mat-panel-title>
              </mat-expansion-panel-header>
              <div class="notes--container">
                <app-underlined-textarea-field
                  [parentForm]="experimentUpdateForm"
                  [field]="noteField"
                  [minLength]="notesMinLength"
                  [maxLength]="notesMaxLength"
                  rows="4"
                  [showCharacterCounter]="true"
                ></app-underlined-textarea-field>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h6>History</h6></mat-panel-title>
              </mat-expansion-panel-header>
              <div id="history--container">
                <table mat-table [dataSource]="changelogList()">
                  <ng-container matColumnDef="date">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      (click)="onSort('CreatedAt')"
                      (keydown.enter)="onSort('CreatedAt')"
                      [class.active]="currentSort().sortBy === 'CreatedAt'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'CreatedAt'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      tabindex="0"
                      role="columnheader"
                    >
                      <span class="sortable">
                        Date
                        <span class="sort-icons" aria-hidden="true">
                          <mat-icon>arrow_drop_up</mat-icon>
                          <mat-icon>arrow_drop_down</mat-icon>
                        </span>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let log">
                      {{ log.createdAt | date: "dd/MM/y - h:mm a" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="note">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      (click)="onSort('NoteText')"
                      (keydown.enter)="onSort('NoteText')"
                      [class.active]="currentSort().sortBy === 'NoteText'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'NoteText'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      tabindex="0"
                      role="columnheader"
                    >
                      <span class="sortable">
                        Note
                        <span class="sort-icons" aria-hidden="true">
                          <mat-icon>arrow_drop_up</mat-icon>
                          <mat-icon>arrow_drop_down</mat-icon>
                        </span>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let log">{{ log.noteText }}</td>
                  </ng-container>

                  <ng-container matColumnDef="change">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      (click)="onSort('ChangeText')"
                      (keydown.enter)="onSort('ChangeText')"
                      [class.active]="currentSort().sortBy === 'ChangeText'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'ChangeText'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      tabindex="0"
                      role="columnheader"
                    >
                      <span class="sortable">
                        Logged Change
                        <span class="sort-icons" aria-hidden="true">
                          <mat-icon>arrow_drop_up</mat-icon>
                          <mat-icon>arrow_drop_down</mat-icon>
                        </span>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let log">{{ log.changeText }}</td>
                  </ng-container>

                  <ng-container matColumnDef="user">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      (click)="onSort('CreatedBy')"
                      (keydown.enter)="onSort('CreatedBy')"
                      [class.active]="currentSort().sortBy === 'CreatedBy'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'CreatedBy'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      tabindex="0"
                      role="columnheader"
                    >
                      <span class="sortable">
                        User
                        <span class="sort-icons" aria-hidden="true">
                          <mat-icon>arrow_drop_up</mat-icon>
                          <mat-icon>arrow_drop_down</mat-icon>
                        </span>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let log">{{ log.createdBy }}</td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="changelogDisplayedColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: changelogDisplayedColumns"
                  ></tr>
                  <tr *matNoDataRow>
                    <td [attr.colspan]="4" id="empty-state">
                      <mat-icon id="empty-state--icon">article</mat-icon>
                      <p id="empty-state--title">
                        {{
                          changelogError()
                            ? changelogError().message
                            : "No Changelogs"
                        }}
                      </p>
                    </td>
                  </tr>
                </table>
                <div id="pagination--container">
                  <app-dropdown-form-field
                    id="changelogs-per-page"
                    [field]="changeLogsPerPageField"
                    [parentForm]="paginationControls"
                  >
                  </app-dropdown-form-field>
                  <div id="pagination--controls">
                    <app-icon-button
                      iconName="chevron_left"
                      buttonId="previous"
                      (buttonClicked)="getPrevious()"
                      [isDisabled]="!hasPrevious()"
                    ></app-icon-button>
                    <span> {{ currentPage() }} / {{ totalPages() }} </span>
                    <app-icon-button
                      iconName="chevron_right"
                      buttonId="next"
                      (buttonClicked)="getNext()"
                      [isDisabled]="!hasNext()"
                    ></app-icon-button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </form>
      </div>
      <div id="button--container">
        <app-button
          label="undo"
          buttonId="undo-btn"
          buttonStyle="yellow"
          [isDisabled]="
            experiment?.isDeleted === true ||
            updateExperimentProcessing() ||
            experiment?.experimentStatusId !== ExperimentStatus.Active ||
            !(currentUser().role | roleCheck: editAccessRoles)
          "
          (click)="handleUndoButton()"
        ></app-button>
        <div id="button--container-right">
          <app-button
            label="save"
            buttonId="apply-btn"
            [isProcessing]="updateExperimentProcessing()"
            [isDisabled]="
              experiment?.isDeleted === true ||
              experimentUpdateForm.pristine ||
              updateExperimentProcessing() ||
              (experiment?.experimentStatusId !== ExperimentStatus.Active &&
                experiment?.experimentStatusId !== ExperimentStatus.Complete) ||
              !(currentUser().role | roleCheck: editAccessRoles)
            "
            (click)="onSubmitExperimentUpdateForm()"
          ></app-button>
        </div>
      </div>
    } @else {
      @if (error()) {
        <div id="error--container">
          <h4>Something went wrong.</h4>
          <p class="error">Error: {{ error()?.message }}</p>
        </div>
      }
    }
  </div>
} @else {
  <app-error-page
    [primaryText]="getExperimentError()?.message"
  ></app-error-page>
}
<app-validation-modal
  id="stop-experiment"
  titleText="Stop experiment"
  primaryText="Are you sure you want to stop this experiment?"
  validationText="stop"
  primaryButtonText="Stop experiment"
  primaryButtonId="primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="secondary-button"
  (modalButtonClicked)="onStopExperiment()"
  [error]="error()"
></app-validation-modal>
<app-validation-modal
  id="pause-devices"
  [titleText]="pauseDeviceTitleText()"
  [validationText]="pauseDeviceValidationText()"
  [primaryButtonText]="pauseDeviceButtonText()"
  primaryButtonId="primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="secondary-button"
  (modalButtonClicked)="pauseDevicesOnExperiment()"
  [error]="error()"
></app-validation-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="update-experiment"
  modalStyle="success"
  titleText="Success"
  primaryText="Experiment updated."
  primaryButtonText="close"
  primaryButtonId="close-success-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-experiment"
  titleText="Delete experiment?"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="confirm-delete-button"
  (modalButtonClicked)="deleteExperiment()"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-delete-button"
  [error]="deleteError()"
></app-validation-modal>
<app-modal
  id="delete-success"
  titleText="Success"
  primaryText="Experiment was deleted."
  primaryButtonText="Go to dashboard"
  primaryButtonId="delete-success-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
<app-modal
  id="delete-error"
  titleText="Unable to delete experiment"
  [primaryText]="deleteError()?.message + '. Choose an action below'"
  buttonLayout="double-button"
  primaryButtonText="Go to dashboard"
  primaryButtonId="error-primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="error-secondary-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
